module.exports = __webpack_public_path__ + "img/luoyangyingtianmen big (10).00d0d539.jpg";